<div class="welcome-banner">
    <div class="welcome-message">
        {{ 'DASHBOARD_PRIVATE.WELCOME' | translate }}
    </div>
    <div class="user-name">{{ authenticationApiService.name$ | async }}</div>
    <div class="personal-area-description">{{ 'DASHBOARD_PRIVATE.THIS_IS_YOUR_PERSONAL_AREA' | translate }}</div>
</div>
<div class="redirect-banners">
    @if (settings?.companySearch?.enabled) {
        <div class="banner-wrapper" [routerLink]="['/company-search-workflow']" (click)="trackDealerBannerButton()">
            <div class="dark-background"></div>
            <div
                aria-hidden="true"
                class="dealer-banner"
                [style.background-image]="'url(' + dealerBannerImgSrc + ')'"
            ></div>
            <button
                class="dealer-button"
                color="primary"
                id="find-dealer"
                mat-stroked-button
                type="button"
                [attr.aria-label]="'FIND_A_DEALER' | translate"
            >
                <div class="banner-name">{{ 'FIND_A_DEALER' | translate }}</div>
            </button>
            <warema-svg-icon aria-hidden="true" filePath="assets/images/location.svg" height="18" width="12" />
        </div>
    }

    @if (settings?.companySearch?.enabled) {
        <div
            class="banner-wrapper"
            [routerLink]="['/company-search-workflow']"
            (click)="trackAppointmentBannerButton()"
        >
            <div class="dark-background"></div>
            <div
                aria-hidden="true"
                class="appointment-banner"
                [style.background-image]="'url(' + appointmentBannerImgScr + ')'"
            ></div>
            <button
                class="appointment-button"
                color="primary"
                id="select-appointment"
                mat-stroked-button
                type="button"
                [attr.aria-label]="'GET_AN_APPOINTMENT' | translate"
            >
                <div class="banner-name">{{ 'GET_AN_APPOINTMENT' | translate }}</div>
            </button>
            <warema-svg-icon aria-hidden="true" filePath="assets/images/icons/calculation.svg" height="17" width="13" />
        </div>
    }

    @if (settings?.productRegistration?.enabled) {
        <div class="banner-wrapper" [routerLink]="['/products-registration']">
            <div class="dark-background"></div>
            <div
                aria-hidden="true"
                class="product-registration-banner"
                [style.background-image]="'url(' + productRegistrationBannerImgScr + ')'"
            ></div>
            <button
                class="product-registration-button"
                color="primary"
                mat-stroked-button
                type="button"
                [attr.aria-label]="'REGISTER_YOUR_PRODUCT' | translate"
            >
                <div class="banner-name">{{ 'REGISTER_YOUR_PRODUCT' | translate }}</div>
            </button>
            <warema-svg-icon aria-hidden="true" filePath="assets/images/icons/check.svg" height="20" width="20" />
        </div>
    }

    @if (settings?.shop?.enabled) {
        <div class="banner-wrapper" [routerLink]="['/shop']">
            <div class="dark-background"></div>
            <div
                aria-hidden="true"
                class="shop-banner"
                [style.background-image]="'url(' + shopBannerImgScr + ')'"
            ></div>
            <button
                class="shop-button"
                color="primary"
                mat-stroked-button
                type="button"
                [attr.aria-label]="'ORDER_FREE_SAMPLES' | translate"
            >
                <div class="banner-name">{{ 'ORDER_FREE_SAMPLES' | translate }}</div>
            </button>
            <warema-svg-icon aria-hidden="true" filePath="shared-assets/icons/shop/cart.svg" height="20" width="20" />
        </div>
    }

    @if (settings?.appointment?.enabled) {
        <div class="banner-wrapper" [routerLink]="['/appointments']">
            <div class="dark-background"></div>
            <div
                aria-hidden="true"
                class="appointments-banner"
                [style.background-image]="'url(' + appointmentsBannerImgScr + ')'"
            ></div>
            <button
                class="appointments-button"
                color="primary"
                mat-stroked-button
                type="button"
                [attr.aria-label]="'MY_APPOINTMENTS' | translate"
            >
                <div class="banner-name">{{ 'MY_APPOINTMENTS' | translate }}</div>
            </button>
            <warema-svg-icon
                aria-hidden="true"
                filePath="shared-assets/icons/icon_calendar.svg"
                height="20"
                width="20"
            />
        </div>
    }

    @if (settings?.configurator?.isRedirectTileVisible) {
        <div class="banner-wrapper" (click)="openWaremaConfigurator()">
            <div class="dark-background"></div>
            <div
                aria-hidden="true"
                class="appointments-banner"
                [style.background-image]="'url(' + configuratorBannerImgScr + ')'"
            ></div>
            <button
                class="appointments-button"
                color="primary"
                mat-stroked-button
                type="button"
                [attr.aria-label]="'CONFIGURE_DESIRED_PRODUCT' | translate"
            >
                <div class="banner-name">{{ 'CONFIGURE_DESIRED_PRODUCT' | translate }}</div>
            </button>
            <warema-svg-icon aria-hidden="true" filePath="assets/images/icons/edit.svg" height="20" width="20" />
        </div>
    }
</div>
